import "./Optimisation.scss";

export default function Optimisation() {
  return (
    <div className="optimisation_page">
      <h1>Optimisation & Suivi</h1>

      <p>
        J’assure l’amélioration continue de votre site web afin de garantir
        ses performances, sa sécurité et sa visibilité sur le long terme.
      </p>

      <ul>
        <li>Optimisation des performances (vitesse, code, expérience utilisateur)</li>
        <li>Amélioration du référencement naturel (SEO)</li>
        <li>Maintenance et mises à jour techniques</li>
        <li>Correction de bugs et amélioration continue</li>
        <li>Suivi des performances du site</li>
      </ul>

      <p>
        Un site web n’est jamais figé : il évolue avec votre activité.
        Mon objectif est de garantir un site rapide, fiable et toujours performant.
      </p>

      <div className="benefits">
        <h2>Pourquoi c’est important ?</h2>

        <ul>
          <li>Meilleure visibilité sur Google</li>
          <li>Expérience utilisateur optimisée</li>
          <li>Site sécurisé et à jour</li>
          <li>Performance améliorée sur tous les appareils</li>
        </ul>
      </div>

      
    </div>
  );
}